import type { ClientSpecMapEntry } from '@wix/document-services-types'

export const AppSpecUpdatedHandlerSymbol = Symbol('AppSpecUpdatedHandler')

export type IAppSpecUpdatedHandler = {
	onAppSpecUpdated: (appData: ClientSpecMapEntry) => Promise<void>
}
